import { Brain, Users, Target, Headphones, Briefcase, CheckCircle2 } from "lucide-react";

const items = [
  {
    icon: Brain,
    title: "AI-First Learning",
    text: "We don't teach Selenium the 2018 way. You'll use ChatGPT, Copilot and prompts to 10x your script-writing speed from day one.",
  },
  {
    icon: Target,
    title: "Industry-Focused Curriculum",
    text: "Built after reviewing 500+ job descriptions from Indian service & product companies. You learn what hiring managers ask for.",
  },
  {
    icon: Users,
    title: "Step-by-Step Mentorship",
    text: "Not a YouTube dump. Live coaching, code reviews, and structured weekly milestones so you never feel lost.",
  },
  {
    icon: Headphones,
    title: "Doubt Support That Actually Responds",
    text: "WhatsApp mentor group + 48-hour doubt-clearing SLA. Your stuck script gets unstuck before it kills your motivation.",
  },
  {
    icon: Briefcase,
    title: "Real Projects, Real Portfolio",
    text: "3 production-grade projects on GitHub + a pre-built framework. Recruiters see proof, not just certificates.",
  },
  {
    icon: CheckCircle2,
    title: "Job-Switch Playbook",
    text: "Resume makeover, mock interviews, salary negotiation scripts. We prepare you for the offer, not just the interview.",
  },
];

export default function USP() {
  return (
    <section className="relative py-20 md:py-32 px-6 md:px-10" data-testid="usp-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <div className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#38BDF8]">
            Why BYMAT?
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-normal text-white mt-4 leading-tight">
            Not just another{" "}
            <span className="text-slate-500">"online course".</span>
          </h2>
          <p className="mt-6 text-lg text-slate-400 leading-relaxed">
            We fixed every broken thing about how automation is taught in India.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {items.map((it, i) => (
            <div
              key={i}
              className="card-hover bg-slate-900/60 border border-slate-800 rounded-2xl p-7"
              data-testid={`usp-card-${i}`}
            >
              <it.icon className="w-7 h-7 text-[#38BDF8] mb-5" />
              <h3 className="font-display text-xl font-normal text-white">
                {it.title}
              </h3>
              <p className="mt-3 text-slate-400 text-sm leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
